export const appConfig = {
    port:{
        port: process.env[`PORT`] ?? 3233
    },
    database: {
        type: process.env[`APP_DB_TYPE`] || 'mysql',
        host: process.env[`APP_DB_HOST`] || '206.189.138.212',
        port: parseInt(process.env[`APP_DB_PORT`]) || 3306,
        username: process.env[`APP_DB_USER`] || 'sa_dev_user',
        password: process.env[`APP_DB_PASS`] || 'Schemax@23',
        dbName: process.env[`APP_DB_DBNAME`] || 'whatsapp_bi',
        poolLimit: parseInt(process.env[`APP_DB_POOL_LIMIT`]) || 50
    },
    thirdPartyDatabase:{
        SA:{
            type: process.env[`HRMS_SA_DB_TYPE`] || 'mysql',
            host: process.env[`HRMS_SA_DB_HOST`] || '206.189.138.212',
            port: parseInt(process.env[`HRMS_SA_DB_PORT`]) || 3306,
            username: process.env[`HRMS_SA_DB_USER`] || 'sa_dev_user',
            password: process.env[`HRMS_SA_DB_PASS`] || 'Schemax@23',
            dbName: process.env[`HRMS_SA_DB_DBNAME`] || 'erpx_dev_masters',
        },
        SCX:{
            //HAVE TO GIVE SCHEMAX DB CREDENTIALS
            type: process.env[`HRMS_SCX_DB_TYPE`] || 'mysql',
            host: process.env[`HRMS_SCX_DB_HOST`] || 'prox.schemaxtech.in',
            port: parseInt(process.env[`HRMS_SCX_DB_PORT`]) || 3306,
            username: process.env[`HRMS_SCX_DB_USER`] || 'ramakrishna',
            password: process.env[`HRMS_SCX_DB_PASS`] || 'Schemax@23',
            dbName: process.env[`HRMS_SCX_DB_DBNAME`] || 'tasktracker',
        },
        GYM: {
            type: process.env[`GYM_DB_TYPE`] || 'mysql',
            host: process.env[`GYM_DB_HOST`] || 'prox.schemaxtech.in',
            port: parseInt(process.env[`GYM_DB_PORT`]) || 3306,
            username: process.env[`GYM_DB_USER`] || 'ramakrishna',
            password: process.env[`GYM_DB_PASS`] || 'Schemax@23',
            dbName: process.env[`GYM_DB_DBNAME`] || 'tasktracker',
        }
    }
}